import React, { useId, useState } from 'react';
import { policyPath } from '../legal/policyRegistry';

export default function GuestUploadNotice({ notice }) {
  const [checked, setChecked] = useState(false);
  const [error, setError] = useState('');
  const headingId = useId();
  if (!notice.required || notice.acknowledged) return null;
  const confirm = () => {
    if (!checked) return;
    try { notice.confirm(); setError(''); }
    catch (failure) { setError(failure.message); }
  };
  return (
    <section aria-labelledby={headingId} className="mb-5 rounded-xl border border-accent bg-surface p-5 text-sm leading-relaxed text-secondary">
      <h2 id={headingId} className="text-lg font-semibold">Before your first upload</h2>
      {notice.updateRequired ? (
        <p className="mt-3" role="alert">The upload notice has changed. Reload this page, or close and reopen Wedlinx to update, before confirming the current notice.</p>
      ) : (
        <>
          <ul className="my-3 list-disc space-y-2 pl-5">
            <li>You keep the copyright in your photos and videos. You give the gallery owner lasting permission to view, download, keep and share them for personal use.</li>
            <li>Wedlinx uses and stores your uploads only to run this gallery.</li>
            <li>Upload only content you have the right to share. Intimate images shared without consent and abusive images of children are not allowed.</li>
          </ul>
          <p className="mb-3">
            Read the{' '}
            <a className="underline" href={policyPath('terms', notice.active.versions.terms)} target="_blank" rel="noopener noreferrer">Terms of Service</a>
            {' '}and{' '}
            <a className="underline" href={policyPath('privacy', notice.active.versions.privacy)} target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
          </p>
          <label className="flex min-h-11 cursor-pointer items-start gap-3 py-2">
            <input type="checkbox" checked={checked} onChange={(event) => setChecked(event.target.checked)} className="mt-1 h-5 w-5 shrink-0" />
            <span>I have read this notice and have the right to upload these files.</span>
          </label>
          {error && <p role="alert" className="my-2">{error}</p>}
          <button type="button" onClick={confirm} disabled={!checked} className="mt-2 min-h-11 rounded-lg bg-primary px-5 py-3 font-medium text-surface disabled:opacity-50">Confirm and continue</button>
          <p className="mt-2 text-xs text-secondary-70">Notice version {notice.active.guestNoticeVersion}. Once confirmed, you can queue uploads while offline.</p>
        </>
      )}
    </section>
  );
}
